import React from "react";

export default function About() {
  return (
    <div className="about-container">
      <h1>About UsPage.</h1>
      <p>About inside edge betting</p>
    </div>
  );
}
